import {Col, ColType, Crud, CrudAction, CrudApi} from "../../comp/crud";
import {
    ApiClient, displayPaidMethod, getPaidMethodOpt, displayMortgageLoanType,
    displayRepaymentPlanStatus, getLoanTypeItemOpt,
    getRepaymentPlanStatusOpt, RepaymentPlanStatus,
} from "../../api/ApiClient";
import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import {
    Form,
    Modal,
    Typography,
    Toast,
    InputNumber,
    DatePicker,
    Tag,
    TabPane,
    Tabs,
    Button,
    Descriptions, Row, List, Table, Popover
} from '@douyinfe/semi-ui';
import {FormApi} from "@douyinfe/semi-ui/lib/es/form";
import {formatAmountZhCn, formatDate, renderStatDetailContentPlan, renderRepaymentPlanStatusTag, renderPaidMethodTag} from "../../utils";
import {
    IconCoinMoneyStroked,
    IconIdCard,
    IconModalStroked,
    IconMoneyExchangeStroked,
    IconUser,
    IconBarChartHStroked,
} from "@douyinfe/semi-icons";
import {Col as RowCol} from "@douyinfe/semi-ui/lib/es/grid";

let apiClient = ApiClient.getDefault();
const {Text} = Typography;

export interface RepaymentPlanProps {
    loanId?: number;
}

export default function IndexRepaymentPlan(props: RepaymentPlanProps) {
    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const [crudApiCard, setCrudApiCard] = useState(undefined as undefined | CrudApi);
    const [crudApiBorrow, setCrudApiBorrow] = useState(undefined as undefined | CrudApi);
    const [showModifyModal, setShowModifyModal] = useState(false);
    const [modifyFormApi, setModifyFormApi] = useState(
        undefined as undefined | FormApi
    );
    const [selectedPlan, setSelectedPlan] = useState({} as any);
    const [selectedPlanList, setSelectedPlanList] = useState([] as any);
    const [modifySaving, setModifySaving] = useState(false);
    const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
    const [modalTitle, setModalTitle] = useState("还款");
    const [currentTab, setCurrentTab] = useState("1");
    const [savingTodo, setSavingTodo] = useState(false);
    const [statData, setStatData] = useState([] as any[]);
    const [statDataObj, setStatDataObj] = useState({} as any);
    const [statDataCard, setStatDataCard] = useState([] as any[]);
    const [statDataObjCard, setStatDataObjCard] = useState({} as any);
    const [statDataBorrow, setStatDataBorrow] = useState([] as any[]);
    const [statDataObjBorrow, setStatDataObjBorrow] = useState({} as any);
    const [batchActions, setBatchActions] = useState([] as any[]);
    const [payType, setPayType] = useState(undefined as string | undefined);
    const username = localStorage.getItem("username");
    const role = localStorage.getItem("role");

    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInList: true,
            type: ColType.NUMBER
        },
        {
            name: "贷款ID",
            key: "loanId",
            hideInEdit: true,
            hideInList: true,
            showInFilter: false,
            type: ColType.NUMBER,
        },

        {
            name: "客户ID",
            key: "leadId",
            width: 80,
            hideInEdit: true,
            hideInList: true,
            showInFilter: true,
            type: ColType.NUMBER,
        },
        {
            name: "客户姓名",
            key: "leadName",
            width: 80,
            hideInEdit: true,
            hideInList: false,
            showInFilter: true,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Button
                        theme="borderless"
                        type="primary"
                        onClick={() => openMortgageLoanModal(record.leadId,record.leadName)}
                    >
                        {value}
                    </Button>
                );

            },
        },
        {
            name: "城市",
            key: "leadCity",
            width: 50,
            hideInEdit: true,
            hideInList: false,
            showInFilter: false,
            type: ColType.STRING,
        },
    
        {
            name: "按揭专员ID",
            key: "agentId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "按揭专员",
            key: "agentName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售ID",
            key: "saleId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售",
            key: "saleName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "贷款类型",
            key: "loanType",
            width: 100,
            type: ColType.SELECT,
            hideInList: false,
            showInFilter: true,
            render: (v, i) => displayMortgageLoanType(v),
            getOptions: () => Promise.resolve(getLoanTypeItemOpt()),
        },
        {
            name: "贷款平台",
            key: "platform",
            width: 100,
            type: ColType.STRING,
            showInFilter: true,
        },
        {
            name: "贷款金额",
            key: "amount",
            width: 70,
            type: ColType.NUMBER,
            render: (a) => formatAmountZhCn(a),
        },
        {
            name: "期数",
            key: "periodNo",
            width: 70,
            type: ColType.STRING,
            render: (value,record, index) => {
                if (record.createdBy&&record.createdBy>0) {
                    return (
                        <Tag color={"blue"} key={value} size='large'
                             shape='circle'
                             type='solid'> {value}期 </Tag>
                    );
                }else if (record.paidUserName == record.leadName) {
                    return (
                        <Tag color={"orange"} key={value} size='large'
                             shape='circle'
                             type='solid'> {value}期 </Tag>
                    );
                }  else {
                    return value+"期";
                }
            },
        },
        
        {
            name: "月供金额",
            key: "oneTermAmount",
            width: 70,
            type: ColType.NUMBER,
            render: (a) => formatAmountZhCn(a),
        },
        {
            name: "计息日期",
            key: "borrowPlanStartDate",
            width: 90,
            type: ColType.DATE_RANGE,
            showInFilter: true,
            defaultSortOrder: false,
        },
        {
            name: "应还日期",
            key: "dueDate",
            width: 90,
            type: ColType.DATE_RANGE,
            showInFilter: true,
            defaultSortOrder: false,
        },
        {
            name: "借款人",
            key: "borrowerName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
   
        },

        {
            name: "借款日期",
            key: "borrowDate",
            width: 70,
            type: ColType.DATE,
        },
        
        {
            name: "状态",
            key: "status",
            width: 70,
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            render: (value, record, index) => renderRepaymentPlanStatusTag(value, record),
            getOptions: (row) => Promise.resolve(getRepaymentPlanStatusOpt())
        },
       
        {
                    name: "还款方式",
                    key: "paidMethod",
                    width: 100,
                    type: ColType.SELECT,
                    showInFilter: true,
                    hideInEdit: true,
                    hideInCreate: true,
                    render: (value) => renderPaidMethodTag(value),
                    getOptions: (row) => Promise.resolve(getPaidMethodOpt())
                },
       
        {
            name: "还款人",
            key: "paidUserName",
            width: 80,
            type: ColType.STRING,
            hideInCreate: true,
            showInFilter: true,
        },
        {
            name: "还款日期",
            key: "paidDate",
            width: 90,
            type: ColType.DATE,
            hideInCreate: true,
        },
        {
            name: "过账金额",
            key: "postingAmount",
            width: 70,
            type: ColType.STRING,
            hideInCreate: true,
            hideInList: currentTab == "1",
            render: (a) => formatAmountZhCn(a),
        },
        {
            name: "还款天数",
            key: "paidDays",
            width: 40,
            type: ColType.NUMBER,
            hideInCreate: true,
        },
        {
            name: "贷款编号",
            key: "loanNo",
            type: ColType.STRING,
            showInFilter: true,
            hideInList: false,
            hideInCreate: true,
            hideInEdit: true,
            width: 110,
        },
    ]

    

    useEffect(() => {
        let currUsername;
        if (role == "op_manager" || role == "monitor") {
            currUsername = "root";
        } else {
            currUsername = username;
        }
        //获取所有销售和按揭专员
        apiClient
            .getTeamMemberByDataScopeAsOpts("payment")
            .then((opts) => setTeamMembersTree(opts));

        return () => {

        };
    }, []);

    const renderLabel = (label: any, item: any) => (
        <div style={{
            padding: '6px 8px',
            lineHeight: 1.0
        }}>
            <div style={{
                fontWeight: 500,
                color: 'var(--semi-color-text-0)',
                fontSize: 14
            }}>
                {label}
                <span style={{
                    fontSize: 12,
                    color: 'var(--semi-color-text-2)',
                    marginLeft: 10
                }}>
                {item.labelSubText}
            </span>
            </div>
        </div>
    );

    const deleteRepaymentPlan = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        //存在还款的计划，请先取消还款再删除
        if (rows.some((item: any) => item.status == RepaymentPlanStatus.YJQ)) {
            Toast.info("存在已还款的计划，请先取消还款再删除");
            return;
        }
        //存在创建人为null的计划
        if (rows.some((item: any) => !item.createdBy || item.createdBy <= 0)) {
            Toast.info("存在系统自动生成的计划，只能删除手动生成的计划");
            return;
        }
        //转换为ids
        let ids = rows.map((item: any) => item.id);
        Modal.confirm({
            title: "是否确认删除还款计划?",
            content: "",
            onOk: async () => {
                try {
                    let params = {
                        id: row.id,
                        ids: ids
                    }

                    await apiClient.request(
                        "/repaymentPlan/delete",
                        "POST",
                        null,
                        params
                    ).then(() => {
                        Toast.success("删除成功");
                        setSelectedPlanList([]);
                        if (currentTab == "1") {
                            crudApi?.refresh();
                        } else if (currentTab == "2") {
                            crudApiCard?.refresh();
                        } else {
                            crudApiBorrow?.refresh();
                        }
                    });
                } catch (e) {
                }
            },
        });
    }

    const deleteAction: CrudAction = {
        name: "删除",
        action: deleteRepaymentPlan,
    };

    const handleCancelModify = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        console.log(rows);
        //没有已还款的计划
        if (!rows.some((item: any) => item.status == "YJQ")) {
            Toast.info("选择的记录中没有已还款的计划，无需取消还款");
            return;
        }
        //转换为ids
        let ids = rows.map((item: any) => item.id);
        Modal.confirm({
            title: "是否确认取消还款?",
            content: "",
            onOk: async () => {
                try {
                    let params = {
                        id: row.id,
                        ids: ids
                    }

                    await apiClient.request(
                        "/repaymentPlan/cancelRepayment",
                        "POST",
                        null,
                        params
                    ).then(() => {
                        Toast.success("取消还款成功");
                        setSelectedPlanList([]);
                        if (currentTab == "1") {
                            crudApi?.refresh();
                        } else if (currentTab == "2") {
                            crudApiCard?.refresh();
                        } else {
                            crudApiBorrow?.refresh();
                        }
                    });

                } catch (e) {
                }
            },
        });
    }

    const cancelModifyAction: CrudAction = {
        name: "取消还款",
        action: handleCancelModify,
    };

    const handleModifyClick = async () => {
        try {
            //判断选择的还款计划数组是否为空
            if (!selectedPlanList || selectedPlanList.length == 0) {
                Toast.info("请选择还款计划");
                return;
            }
            //还款金额不能小于等于0
            if (selectedPlanList.some((item: any) => item.paidAmount <= 0)) {
                Toast.info("还款金额不能小于等于0");
                return;
            }
            //出款人、还款金额、还款日期不能为空
            selectedPlanList.forEach((item: any) => {
                //分别校验出款人、还款金额、还款日期是否为空
                if (!item.paidUserId) {
                    Toast.info("出款人不能为空");
                    return;
                }
                if (!item.paidAmount) {
                    Toast.info("还款金额不能为空");
                    return;
                }
                if (!item.paidDate) {
                    Toast.info("还款日期不能为空");
                    return;
                }
            })

            //信用卡结清，需要提醒操作人，是否将信用卡客户转为[信贷客户]
            if (selectedPlan.paidOptType == "JQ" && currentTab == "2") {
                Modal.confirm({
                    title: "是否确认结清贷款?",
                    content: "结清贷款，是否将信用卡客户转为[信贷客户]?",
                    okText: "是",
                    cancelText: "否",
                    onOk: async () => {
                        doRepayment(true);
                    },
                    onCancel: async () => {
                        doRepayment(false);
                    }
                })
            } else {
                doRepayment(false);
            }

        } catch (e) {
            setModifySaving(false);
        }
    };

    const doRepayment = (isTransform: boolean) => {
        try {
            setModifySaving(true);
            selectedPlanList.forEach((item: any) => {
                item.isTransform = isTransform
            })
            apiClient.request(
                "/repaymentPlan/doRepayment",
                "POST",
                null,
                selectedPlanList
            ).then(res => {
                Toast.success("提交成功");
                setSelectedPlan({});
                setSelectedPlanList([]);
                crudApi?.refresh();
                crudApiCard?.refresh();
                crudApiBorrow?.refresh();
                setModifySaving(false);
                setShowModifyModal(false);
            });

        } catch (e) {
            setModifySaving(false);
        }
    };


    const handleTodoClick = async (plan: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        //转换为ids
        let ids = rows.map((item: any) => item.id);
        Modal.confirm({
            title: "是否确认发送提醒?",
            content: "",
            onOk: async () => {
                try {
                    setSavingTodo(true);

                    await apiClient.request("/repaymentPlan/batchCreatePayLoanTodo", "POST", undefined, {
                        planIds: ids,
                    }).then(() => {
                        Toast.info("已发送提醒信息");
                    });


                } catch (e) {
                }
            },
        });

    };
    const sendTodoAction: CrudAction = {
        name: "提醒",
        action: handleTodoClick,
    };

    const handlePaymentButtonClick = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        //存在已还款的计划，不能进行还款
        if (rows.some((item: any) => item.status == "YJQ")) {
            Toast.info("选中的记录存在已还款的计划，不能进行还款");
            return;
        }
        setModalTitle("批量还款");
        //rows赋值新的数组,清空rows
        let mewRows = JSON.parse(JSON.stringify(rows));
        //循环修改rows的已还款字段
        mewRows.forEach((item: any) => {
            if(!item.paidUserId){
                item.paidUserId = item.agentId;
                item.paidUserName = item.agentName;
                item.paidAmount = item.oneTermAmount;
                item.paidDate = item.dueDate;
            }
            item.payType = "代还";
            item.paidOptType = "HK";
        })
        setSelectedPlanList(mewRows);
        setSelectedPlan({...mewRows[0], paidOptType: "HK"});
        setPayType("代还");

        setShowModifyModal(true);

    };

    const handlePaymentFinishButtonClick = (row: any, rows: any) => {
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        //存在已还款的计划，不能进行还款
        if (rows.some((item: any) => item.status == "YJQ")) {
            Toast.info("选中的记录存在已还款的计划，不能进行结清");
            return;
        }
        setModalTitle("批量结清");
        //循环修改rows的已还款字段
        rows.forEach((item: any) => {
            if(!item.paidUserId){
                item.paidUserId = item.agentId;
                item.paidUserName = item.agentName;
                item.paidAmount = item.oneTermAmount;
                item.paidDate = item.dueDate;
            }
            item.payType = "代还";
            item.paidOptType = "JQ";
        })
        setSelectedPlanList(rows);
        setSelectedPlan({...rows[0], paidOptType: "JQ"});
        setPayType("代还");

        setShowModifyModal(true);

    };
    const handlePaymentGzButtonClick = (row: any, rows: any) => {
        if(currentTab != "2"){
            Toast.info("只有信用卡客户才能进行过账");
            return;
        }
        if (!rows || rows.length == 0) {
            Toast.info("请至少选择一个还款计划");
            return;
        }
        //存在已还款的计划，不能进行还款
        if (rows.some((item: any) => item.status == "YJQ")) {
            Toast.info("选中的记录存在已还款的计划，不能进行过账");
            return;
        }
        setModalTitle("批量过账");
        //循环修改rows的已还款字段
        rows.forEach((item: any) => {
            if(!item.paidUserId){
                item.paidUserId = item.agentId;
                item.paidUserName = item.agentName;
                item.paidAmount = item.oneTermAmount;
                item.paidDate = item.dueDate;
                
            }
            item.payType = "代还";
            item.paidOptType = "GZ";
        })
        setSelectedPlanList(rows);
        setSelectedPlan({...rows[0], paidOptType: "GZ"});
        setPayType("代还");

        setShowModifyModal(true);

    };

    const paymentAction: CrudAction = {
        name: "还款",
        action: handlePaymentButtonClick,
    };
    const paymentFinishAction: CrudAction = {
        name: "结清",
        action: handlePaymentFinishButtonClick,
    };
    const paymentGzAction: CrudAction = {
        name: "过账",
        action: handlePaymentGzButtonClick,
    };


    let nowDate = new Date();
    let nowDateStr = formatDate(nowDate);
    //计算nowDate的所在月份的第一天和最后一天
    let startDate = new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1);
    let endDate = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
    const [initFilterValues, setInitFilterValues] = useState({
        //dueDate: [startDate, endDate],
    });
    let startDateStr = formatDate(startDate);
    let endDateStr = formatDate(endDate);
    const initParams = {
        //dueDate: startDateStr + "," + endDateStr,
    };

    
    //打开详情
    const detailAction = (a: any) => {
        const w = window.open("about:blank");
        let queryParams = {
            ...crudApi?.getQueryParams(),
            type: 'all'
        }
        if (w != null) {
            //获取表格data的id列表
            const ids = crudApi?.getData()?.map((i) => i.leadId);
            const data = {
                id: a.leadId,
                ids: ids,
                viewMode: true,
                visitMode: false,
                leadFrom: 'report',
                queryParams: queryParams,
            };
            w.location.href =
                "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
        }
    };

    // 功能12: 打开贷款详情页面
  // 跳转到新窗口 /#/newleadLoan，传入客户ID和姓名
  // 对应二级页面 indexMortgageLoan.tsx (entityKey: mortgageLoan/listGroupPlatform)
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

    const actions: CrudAction[] = [
        {
            name: "还款",
            action: handlePaymentButtonClick,
        },
        {
            name: "结清",
            action: handlePaymentFinishButtonClick,
        },
        {
            name: "过账",
            action: handlePaymentGzButtonClick,
        },
        {
            name: "提醒",
            action: handleTodoClick,
        },
        {
            name: "取消还款",
            action: handleCancelModify,
        },
        {
            name: "删除",
            action: deleteRepaymentPlan,
        },
    ];

    useEffect(() => {
        
        //刷新统计
        initStatCountData();
    }, [statDataObj]);

    const queryStatCount = async (data: any) => {
        let params = {
            ...data,
        };
        console.log("统计报表查询参数：", params);
        apiClient.request("/repaymentPlan/listSum", "GET", data).then((resp) => {
            setStatDataObj(resp.data);
        });
    };

    const initStatCountData = async () => {
        console.log("统计报表返回数据：", statDataObj);
        if (!statDataObj) {
            return;
        }

        const data = [
            {key: "", value: "贷款"},
             { key: "贷款金额", value: formatAmountZhCn(statDataObj.loanAmount) },
                  { key: "代还金额", value: formatAmountZhCn(statDataObj.loanHelpRepaymentPlanAmount) },
                  { key: "客户自还金额", value: formatAmountZhCn(statDataObj.loanRepaymentPlanAmount - statDataObj.loanHelpRepaymentPlanAmount) },
                  { key: "月供汇总", value: statDataObj.oneTermAmount },
           {key: "", value: "信用卡"},
             { key: "信用卡代还金额", value: formatAmountZhCn(statDataObj.cardHelpRepaymentPlanAmount) },
                  { key: "信用卡代过账金额", value: formatAmountZhCn(statDataObj.cardHelpPostingPlanAmount) },
                  { key: "信用卡客户自还金额", value: formatAmountZhCn(statDataObj.cardRepaymentPlanAmount - statDataObj.cardHelpRepaymentPlanAmount + statDataObj.cardPostingPlanAmount - statDataObj.cardHelpPostingPlanAmount) },
         {key: "", value: "借款"},
                  { key: "出借金额", value: formatAmountZhCn(statDataObj.borrowAmount) },
              { key: "借款归还金额", value: formatAmountZhCn(statDataObj.borrowReturnAmount) },
              { key: "剩余金额", value: formatAmountZhCn(statDataObj.borrowAmount - statDataObj.borrowReturnAmount) },


        ];
        setStatData(data);
    };


    const listSumStat = () => {
        const style = {
            boxShadow: "var(--semi-shadow-elevated)",
            backgroundColor: "var(--semi-color-bg-2)",
            borderRadius: "4px",
            padding: "10px",
            margin: "auto",
        };
        return (
            <div style={{display: "flex", width: "100%", margin: "5px", alignItems: "center"}}>
                <Popover content={renderStatDetailContentPlan(statDataObj)} trigger="hover" position="bottomLeft" showArrow>
                    <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked style={{marginRight: 4}}/>统计详情</a>
                </Popover>
                <Descriptions data={statData} row style={style}/>
            </div>
        );
    };

    // 行点击事件处理
    const handleRowClick = (record: any) => {
        if(record.leadName == "汇总"){
            return;
        }

        // 填充表单
        const {...rest} = record;
        console.log(rest);
        setPayType(record.payType);
        // 设置当前活动行
        setSelectedPlan(rest);
        // 如果表单API可用，设置值
        if (modifyFormApi) {
            modifyFormApi.setValues(rest);
        }
    };
    // 处理表单提交
    const handleFormSubmit = async (value:any, valueType: any) => {
        //await modifyFormApi?.validate();
        const values: any = modifyFormApi?.getValues();
        if(valueType==1){
            values.paidUserId = value;
        }else if(valueType==2){
            values.paidAmount = value;
        }else if(valueType==3){
            values.paidDate = value;
        }
        // 获取当前选中的付款人名称
        let paidUserName = "";
        teamMembersTree.forEach((item: any) => {
            if (item.value === values.paidUserId) {
                paidUserName = item.label;
            }
        });

        // 更新现有数据
        const updatedData = selectedPlanList.map((p: any) =>
            p.id === selectedPlan.id ? {
                ...p,
                paidUserId: values.paidUserId,
                paidUserName:  paidUserName,
                paidAmount: values.paidAmount,
                paidDate: formatDate(values.paidDate)
            } : p
        );
        setSelectedPlanList(updatedData);
        //console.log("修改后的数据：", selectedPlanList);
        //Toast.success("已保存");
    };

    // 计算汇总数据
    const summary = useMemo(() => {
        if(selectedPlanList&&selectedPlanList.length>0){
            return {
                oneTermAmount: safeSumBy(selectedPlanList, 'oneTermAmount'),
                paidAmount: safeSumBy(selectedPlanList, 'paidAmount'),
            };

        }else{
            return {
                oneTermAmount: 0,
            };
        }

    }, [selectedPlanList]);

    /**
     * 计算属性安全总和
     * @param items 对象数组
     * @param prop 数字类型的属性名
     * @returns 有效数字的总和
     */
    function safeSumBy<T>(items: T[], prop: keyof T): number {
        return items.reduce((sum, item) => {
            const value = item[prop];

            // 类型安全验证
            if (typeof value === 'number' && !isNaN(value)) {
                return sum + value;
            }

            // 尝试转换为数字
            const numericValue = Number(value);
            return !isNaN(numericValue) ? sum + numericValue : sum;
        }, 0);
    }
    // 合并数据和汇总行
    const dataWithSummary = [{
        key: 'summary',
        leadName: '汇总',
        id: 999999,
        leadId: 999999,
        oneTermAmount: summary.oneTermAmount,
        paidAmount: summary.paidAmount,
    },...selectedPlanList];

    const changePayType = (payType: any) => {
        console.log("选择还款方式：", payType);
        setPayType(payType);
        if (payType === '代还') {
            modifyFormApi!.setValue("paidUserName", selectedPlan.agentName);
            modifyFormApi!.setValue("paidUserId", selectedPlan.agentId);
            //修改selectedPlanList对应的行的paidUserName
            let selectedPlanListUpd = selectedPlanList.map((item: any) => {
                if (item.id === selectedPlan.id) {
                    item.paidUserName = selectedPlan.agentName;
                    item.payType = "代还";
                }
                
                return item;
            });
            setSelectedPlanList(selectedPlanListUpd);
        } else {
            modifyFormApi!.setValue("paidUserName", selectedPlan.leadName);
            //修改selectedPlanList对应的行的paidUserName
            let selectedPlanListUpd = selectedPlanList.map((item: any) => {
                if (item.id === selectedPlan.id) {
                    item.paidUserName = selectedPlan.leadName;
                    item.payType = "客户自还";
                }
                return item;
            });
            setSelectedPlanList(selectedPlanListUpd);
        }
    };

    return <>
        <Modal
            icon={<IconModalStroked size={"extra-large"} style={{color: 'blue'}}/>}
            style={{width: 1000, height: 710}}
            title={modalTitle}
            visible={showModifyModal}
            okText={modalTitle}
            confirmLoading={modifySaving}
            onOk={handleModifyClick}
            onCancel={() => setShowModifyModal(false)}
        >
            <Form getFormApi={(formApi) => setModifyFormApi(formApi)}
                  initValues={selectedPlan}
            >
                <Row>
                    <RowCol span={18}>
                        <Form.Section text={'已选计划'}>
                            <Table
                                rowKey="id"
                                onRow={(record: any, index) => {
                                    return {
                                        style: {
                                            cursor: 'pointer',
                                            backgroundColor: selectedPlan.id === record.id ? 'var(--semi-color-fill-2)' : 'transparent',
                                            transition: 'background-color 0.2s'
                                        },
                                        onClick: () => {
                                            handleRowClick(record);
                                        },
                                    };
                                }}
                                columns={[
                                    {title: "客户姓名", dataIndex: "leadName",render: (text: any, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{text}</Typography.Title>
                                                : text
                                        )},
                                    {title: "平台", dataIndex: "platform"},
                                    {title: "还款方式", dataIndex: "payType"},
                                    {title: "应还金额", dataIndex: "oneTermAmount",render: (text: number, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{formatAmountZhCn(text)}</Typography.Title>
                                                : formatAmountZhCn(text)
                                        )},
                                    {title: "还款日期", dataIndex: "dueDate"},
                                    {title: "出款人", dataIndex: "paidUserName"},
                                    {title: "实际还款金额", dataIndex: "paidAmount",render: (text: number, record: any) => (
                                            record.key === 'summary'
                                                ? <Typography.Title heading={5}>{formatAmountZhCn(text)}</Typography.Title>
                                                : formatAmountZhCn(text)
                                        )},
                                    {title: "实际还款日期", dataIndex: "paidDate"},
                                ]}
                                pagination={{pageSize: 15}}
                                dataSource={dataWithSummary}
                                bordered
                            />
                        </Form.Section>
                    </RowCol>

                    <RowCol span={6}>
                        <Form.Section text={'还款信息'} style={{marginLeft: 20}}>
                        <Form.RadioGroup field="payType" initValue={"代还"} label='还款方式' onChange={(e) => changePayType(e.target.value)}>
                    <Form.Radio value="代还">代还</Form.Radio>
                    <Form.Radio value="客户自还">客户自还</Form.Radio>
                </Form.RadioGroup>
                           {payType === "代还" &&
                            (<Form.Select
                                placeholder="请选择出款人"
                                rules={[{required: true, message: "请选择出款人"}]}
                                label={"出款人"}
                                field="paidUserId"
                                optionList={teamMembersTree}
                                showClear={true}
                                filter={true}
                                style={{width: 200}}
                                onChange={(value: any) => handleFormSubmit(value, 1)}
                                
                            ></Form.Select>
                           )}
                           {payType === "客户自还" && 
                            (<Form.Input
                                style={{width: 200}}
                                key="paidUserName"
                                label="出款人"
                                field="paidUserName"
                                disabled
                            />
                           )}
                            
                            <Form.InputNumber
                                rules={[{required: true, message: "请填写"}]}
                                style={{width: 200}}
                                key="paidAmount"
                                label="还款金额"
                                field="paidAmount"
                                showClear={true}
                                onChange={(value: any) => handleFormSubmit(value, 2)}
                            />
                            <Form.DatePicker
                                rules={[{required: true, message: "请选择实际还款日期"}]}
                                style={{width: 200}}
                                type="date"
                                label="实际还款日期"
                                field="paidDate"
                                showClear={true}
                                onChange={(value: any) => handleFormSubmit(value, 3)}
                            />

                        </Form.Section>
                    </RowCol>
                </Row>

            </Form>
        </Modal>
        <Row>
            <RowCol span={24}>{listSumStat()}</RowCol>
        </Row>
                <Crud
                    getCrudApi={(crudApi) => {
                        setCrudApi(crudApi);
                    }}
                    initFilterValues={initFilterValues}
                    params={{
                        ...initParams,
                    }
                    }
                    canUpdate={false}
                    canCreate={false}
                    canDelete={false}
                    name="计划查询"
                    entityKey="repaymentPlan"
                    pageSize={50}
                    rowActionWidth={40}
                    fetchDataAfterMethod={queryStatCount}
                
                    cols={cols}
                />
          
    </>
}